import React from 'react';
import './style.scss';

const NotFound = (props) => (
    <div className="notfound">
        Error 404: Page Not Found
    </div>
);

export default NotFound;